import { getCurrencySymbol } from 'further-ui/utils';
import UnitsSoldCell from '../UnitsSoldCell';
import CashConsiderationCell from '../CashConsiderationCell';
import { Control } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import LabelCell from '../LabelCell';
import { HoldingClassRealisations } from '../types';
import { Row } from 'components/SectionedTable';

enum KeyType {
  UnitsSold = 'unitsSold',
  CashConsideration = 'cashConsideration',
}

export function getManualConsiderationColumns({
  holdingClassRealisations,
  currencyCode,
  control,
  disabled,
}: {
  holdingClassRealisations: HoldingClassRealisations;
  currencyCode: string;
  control: Control<rules.CreateRealisationFormValues>;
  disabled: boolean;
}) {
  const currencySymbol = getCurrencySymbol(currencyCode);

  return [
    {
      key: 'label',
      label: 'Unit class',
      render: (row: Row) => <LabelCell row={row} />,
    },
    ...holdingClassRealisations.map((holdingClass, colIdx) => ({
      key: holdingClass.holdingClassId,
      label: holdingClass.name,
      render: (row: Row) =>
        row.key === KeyType.UnitsSold ? (
          <UnitsSoldCell value={holdingClass.unitsSold ?? 0} />
        ) : (
          <CashConsiderationCell
            colIdx={colIdx}
            row={row}
            control={control}
            currencySymbol={currencySymbol}
            disabled={disabled}
          />
        ),
    })),
  ];
}
